var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.chartData && _vm.chartOptions)?_c('Bar',{ref:"chart",attrs:{"chart-options":_vm.chartOptions,"chart-data":_vm.chartData,"width":400,"height":600}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }